var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errorAxios)?_c('v-alert',{staticClass:"text-center",attrs:{"type":"error","block":""}},[_vm._v(" "+_vm._s(_vm.$i18n.t('wereSorry'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }